function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { jsx as _jsx } from "react/jsx-runtime";
import { Select } from "@neru/ui";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { mainNavigationConfig } from "../../config";
import { FEATURE_FLAGS, useAuth, useFeatureToggle } from "../../hooks";
var useAppSelector = useSelector;
var MENU_ITEMS = [
    {
        action: mainNavigationConfig.urlAccountOverview,
        icon: "gear-solid",
        title: "Overview"
    }
];
export var AccountSelector = function(param) {
    var _param_withMenu = param.withMenu, withMenu = _param_withMenu === void 0 ? false : _param_withMenu;
    var _accounts_;
    var accounts = useAppSelector(function(param) {
        var accounts = param.accounts;
        return accounts;
    }).accounts;
    var _useAuth = useAuth(), accountId = _useAuth.accountId, saveAccountId = _useAuth.saveAccountId;
    var navigate = useNavigate();
    var _useFeatureToggle = _sliced_to_array(useFeatureToggle(FEATURE_FLAGS.accountOverview), 1), isAccountOverviewOn = _useFeatureToggle[0];
    var menuItems = isAccountOverviewOn && withMenu ? MENU_ITEMS : [];
    return /*#__PURE__*/ _jsx(Select, {
        "data-testid": "account-selector",
        defaultValue: accountId !== null && accountId !== void 0 ? accountId : accounts === null || accounts === void 0 ? void 0 : (_accounts_ = accounts[0]) === null || _accounts_ === void 0 ? void 0 : _accounts_.key,
        disabled: accounts.length <= 1 && !menuItems.length,
        items: accounts.map(function(param) {
            var key = param.key;
            return key;
        }),
        menuItems: isAccountOverviewOn ? menuItems : [],
        onChange: saveAccountId,
        onNavigate: navigate,
        width: 200
    });
};

//# sourceMappingURL=AccountSelector.js.map